// ABOUTME: Ponto de entrada do Stimulus — registra controllers do layout e da aplicação.
// ABOUTME: Ativa debug/warnings em development via meta tag de environment.

import { Application } from "@hotwired/stimulus"
import { railsEnv, layoutControllers } from "@uenf/layout"

const application = Application.start()

if (railsEnv === "development") {
  application.warnings = true
  application.debug    = true
  window.Stimulus      = application
}
for (const [name, controller] of Object.entries(layoutControllers)) {
  application.register(name, controller);
}

import { definitions } from "stimulus:./controllers"
application.load(definitions);

import AddressController from "@uenf/layout/controllers/address"
application.register("address", AddressController);

import AutocompleteController from "@uenf/layout/controllers/autocomplete";
application.register("autocomplete", AutocompleteController);

import CheckboxesAsRadiosController from "@uenf/layout/controllers/checkboxes-as-radios";
application.register("checkboxes-as-radios", CheckboxesAsRadiosController);

import CnpjLookupController from "@uenf/layout/controllers/cnpj-lookup";
application.register("cnpj-lookup", CnpjLookupController);

import CheckboxSelectAll from "@stimulus-components/checkbox-select-all";
application.register("checkbox-select-all", CheckboxSelectAll);

import Clipboard from "@stimulus-components/clipboard";
application.register("clipboard", Clipboard);

import EnsureUploadType from "@uenf/layout/controllers/ensure-upload-type";
application.register("ensure-upload-type", EnsureUploadType);
